<template>
  <template v-if="tag.settingEnabled">
    <slot></slot>
  </template>
  <template v-else>
    <div class="OptionalSettingPopoverContent">
      <h3 v-html="popoverTitle"></h3>
      <slot name="BinSelectionInput"></slot>
      <Listbox :modelValue="selectedOption" :options="options" optionLabel="label" @update:modelValue="onOptionSelected">
        <template #option="{option}">
          <div class="flex">
            <div class="iconBox">
              <i v-if="option == selectedOption" class="pi pi-check" style="font-size: 22px;"></i>
            </div>
            <div>
              {{ option.label }}
            </div>
          </div>
        </template>
      </Listbox>
    </div>
  </template>
</template>

<script setup>
import { computed } from "vue";
import { toggleOptionalSettings } from "./appUtility";

let props = defineProps([
  "tag",
  "showingPopover",
  "popoverTitle",
  "columnSelectionCode",
  "selectedCells"
]);

let showingPopover = defineModel("showingPopover");
let columnSelectionCode = defineModel("columnSelectionCode");

let options = [
  { label: "Setting disabled", value: false },
  { label: "Setting enabled", value: true }
];

let selectedOption = computed(() => {
  return options.find(option => option.value == props.tag.settingEnabled)
});

function onOptionSelected(option)
{
  // The 'option' argument will be null after selecting the already selected option.
  let value = option?.value ?? selectedOption.value.value;

  showingPopover.value = false;
  toggleOptionalSettings(props.selectedCells, value);
}
</script>

<style scoped>
.OptionalSettingPopoverContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}
.p-listbox {
  width: 300px;
  font-size: large;
}
:deep(.p-listbox-item) {
  padding: 15px;
}
:deep(.p-listbox-item).p-highlight {
  color: white;
  border-radius: 0;
  background-color: var(--blue-500);
}
.flex {
  display: flex;
  align-items: center;
  gap: 10px;
}
.iconBox {
  width: 25px;
  display: flex;
  justify-content: center;
}
</style>